"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _clsx3 = _interopRequireDefault(require("clsx"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var InputCard = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(InputCard, _React$Component);

  InputCard.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.isSelected !== undefined) {
      return _objectSpread(_objectSpread({}, state), {}, {
        isSelected: props.isSelected
      });
    }

    return null;
  };

  function InputCard(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var isSelected = props.isSelected || false;

    var onChange = props.onChange || _this.toggleInput.bind((0, _assertThisInitialized2["default"])(_this));

    _this.state = {
      isSelected: isSelected,
      onChange: onChange
    };
    return _this;
  }

  var _proto = InputCard.prototype;

  _proto.toggleInput = function toggleInput() {
    this.setState(function (prevState) {
      return {
        isSelected: !prevState.isSelected
      };
    });
  };

  _proto.render = function render() {
    var _clsx2;

    var _this$props = this.props,
        fullTap = _this$props.fullTap,
        label = _this$props.label,
        cardName = _this$props.cardName,
        value = _this$props.value,
        children = _this$props.children,
        type = _this$props.type,
        classes = _this$props.classes,
        cardId = _this$props.cardId,
        theme = _this$props.theme,
        twoLineLabel = _this$props.twoLineLabel,
        disabled = _this$props.disabled;
    var _this$state = this.state,
        isSelected = _this$state.isSelected,
        onChange = _this$state.onChange;
    var addedClasses = classes.map(function (currentClass) {
      return theme[currentClass] || currentClass;
    });
    var headingClass = (0, _clsx3["default"])(theme.headingFour, theme.optionLabelHeading);

    if (fullTap) {
      var _clsx;

      // Label is the card so that it is all clickable
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
        className: theme.optionCardInput,
        type: type,
        checked: isSelected,
        id: cardId,
        value: value,
        onChange: disabled ? function () {
          return null;
        } : onChange,
        name: cardName,
        disabled: disabled
      }), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: cardId,
        className: _clsx3["default"].apply(void 0, [theme.optionLabel, theme.optionCard].concat(addedClasses))
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _clsx3["default"])(headingClass, (_clsx = {}, _clsx[theme.twoLine] = twoLineLabel, _clsx))
      }, label), children));
    } // Label sits within the card making only it clickable


    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
      className: theme.optionCardInput,
      type: type,
      checked: isSelected,
      id: cardId,
      value: value,
      onChange: disabled ? function () {
        return null;
      } : onChange,
      name: cardName,
      disabled: disabled
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _clsx3["default"].apply(void 0, [theme.optionCard].concat(addedClasses))
    }, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: cardId,
      className: (0, _clsx3["default"])(theme.optionLabel, headingClass, (_clsx2 = {}, _clsx2[theme.twoLine] = twoLineLabel, _clsx2))
    }, label), children));
  };

  return InputCard;
}(_react["default"].Component);

exports["default"] = InputCard;
InputCard.displayName = 'InputCard';
InputCard.defaultProps = {
  classes: [],
  fullTap: false,
  twoLineLabel: false
};